export function focusCountdown(state) {
  const phase = state?.session?.status;
  if (!['running', 'paused', 'break'].includes(phase)) return null;
  const ms = state.remaining;
  if (!Number.isFinite(ms)) return null;
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return { time: `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`,
    label: phase === 'paused' ? 'Paused' : phase === 'break' ? 'Break' : 'Focus' };
}
